<template>
<a :href="notification.link.url" class="is-block top-stripe bg-charcoal" v-if="notification.link && notification.link.url">
    <div class="container">
        <div class="columns is-marginless">
            <div class="column">
                <span>{{notification.message}}</span>
            </div>
            <div class="column is-narrow">
                <span class="button is-small">{{notification.link.title}}</span>
            </div>
        </div>
    </div>
</a>
</template>

<script>
export default {
    name        :   'TopStripe',
    props       :   ['notification']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/TopStripe.vue